export default function (customBlocks) {
  return function (editor) {
    const blockManager = editor.BlockManager

    customBlocks.forEach(customBlock => {
      blockManager.add(customBlock.name, {
        label: customBlock.name,
        category: 'Custom-' + customBlock.category,
        attributes: { class: 'fa fa-cube' },
        content: {
          components: customBlock.content.toString(),
          styles: customBlock.styles?.toString()
        }
      })
    })
  }
}
